/** Extract a displayable message from an unknown thrown value. */
export function getErrorMessage(error: unknown, fallback = 'Something failed. Try again.'): string {
  if (error instanceof Error && error.message) return error.message;
  if (typeof error === 'string' && error) return error;
  return fallback;
}
